import type { ReportType } from '@reports/domain/types';
import { ReportTypes } from '@reports/domain/types';
import type { Report } from '@reports/domain/entities';
import { salesReportDefinition } from './report-definitions/salesReportDefinition';
import { paymentsReportDefinition } from './report-definitions/paymentsReportDefinition';
import { productsReportDefinition } from './report-definitions/productsReportDefinition';
import { cancellationReportDefinition } from './report-definitions/cancellationReportDefinition';

/**
 * Registry of all report definitions
 */
export const reportDefinitionsRegistry: ReadonlyMap<ReportType, Report> = new Map([
  [ReportTypes.SALES, salesReportDefinition],
  [ReportTypes.PAYMENTS, paymentsReportDefinition],
  [ReportTypes.PRODUCTS, productsReportDefinition],
  [ReportTypes.CANCELLATIONS, cancellationReportDefinition],
]);

/**
 * Get a report definition by type
 * @param type - The type of the report
 * @returns The report definition or undefined if not found
 */
export const getReportDefinitionByType = (type: ReportType): Report | undefined => {
  return reportDefinitionsRegistry.get(type);
};

/**
 * Get all report types
 * @returns All report types
 */
export const getAllReportsTypes = (): ReportType[] => {
  return Array.from(reportDefinitionsRegistry.keys());
};
